import { UserPermission, UserSocialNetwork, UserStatus, UserStatusFilter } from 'store/user/types';

export enum UsersListSort {
  default = 'default',
}

export enum UserFieldName {
  fullName = 'fullName',
  password = 'password',
  department = 'department',
  email = 'email',
  phone = 'phone',
  position = 'position',
  status = 'status',
  deviceGroups = 'deviceGroups',
  userGroups = 'userGroups',
  permissions = 'permissions',
  socialNetworks = 'socialNetworks',
  uid = 'uid',
  updateDate = 'updateDate',
  createDate = 'createDate',
  mfaEnabled = 'mfaEnabled',
  forcePasswordRefresh = 'forcePasswordRefresh',
  expirationDate = 'expirationDate',
  role = 'role',
}

export interface UserFormValues {
  password?: string | null;
  fullName?: string;
  department?: string;
  email?: string;
  phone?: string;
  position?: string;
  status?: UserStatus;
  deviceGroups?: number[];
  userGroups?: string[];
  permissions?: UserPermission[];
  socialNetworks?: UserSocialNetwork[];
  mfaEnabled?: boolean;
  forcePasswordRefresh?: boolean;
  expirationDate?: string;
  role?: string;
}

export interface UserLog {
  timestamp: number;
  action: string;
  entity: string;
  log: string;
  createDate?: number;
  initiator?: string;
  uid?: string;
  details?: any;
}

export interface UserLogList {
  timestamp: string;
  log: any;
}

export enum LogFieldName {
  timestamp = 'timestamp',
  log = 'log',
}

export type UpdateUserValues = UserFormValues;

export type CreateUserValues = Required<Pick<UserFormValues, 'email'>> & UserFormValues;

export type UsersFilterFormValues = {
  search: string;
  status?: UserStatusFilter.ACTIVE | UserStatusFilter.INACTIVE | UserStatusFilter.ALL;
  userGroup: any;
  permissions: any;
};
